<template>
  <div class="modalScan">
    <slotModal
      :id-modal="'modalScan'"
      :modal-title="'E-Pay tidak ditemukan'"
      :footer="false"
      v-model="modal"
      @close="close"
      class="titleModal"
    >
      <template v-slot:modal-content>
        <div
          class="content d-flex flex-column justify-content-center align-items-start align-self-stretch"
        >
          <div class="text d-flex flex-column align-items-start p-x-20 p-t-10">
            <p class="f-Overpass f-w-400 f-c-black f-14 my-0">
              Anda belum memiliki saldo E-Pay untuk bertransaksi di outlet ini.
              Sebelum melakukan transaksi, pastikan anda telah mengisi saldo
              E-Pay di kasir.
            </p>
          </div>
          <div
            class="d-flex p-a-20 flex-column justify-content-center align-items-center w-100"
          >
            <button class="btn btn-primary w-100" @click="routeToTopUp">
              Top-Up saldo sekarang
            </button>
          </div>
        </div>
      </template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";

export default {
  name: "modalScan",
  components: {
    slotModal,
  },
  data() {
    return {
      modal: false,
    };
  },

  methods: {
    open() {
      this.modal = true;
    },
    close() {
      this.modal = false;
      location.reload();
    },
    routeToTopUp() {
      this.$router.push({ name: "topup" });
      location.reload();
    },
  },
};
</script>
